import AdminMain from "../modules/adminModule/views/Main.vue";
import Dashboard from "../modules/adminModule/views/Dashboard.vue";
import CreateNewUser from "../modules/adminModule/views/CreateNewUser.vue";
import AllUsers from "../modules/adminModule/views/AllUsers.vue"
import UpdateUser from "../modules/adminModule/views/UpdateUser";
import DeleteUser from "../modules/adminModule/views/DeleteUser";
import Profile from "../modules/adminModule/views/Profile.vue";

export default [
  {
    path: "/admin",
    name: "admin-main-view",
    component: AdminMain,
    children: [
      {
        path: "/admin/dashboard",
        name: "admin-dashboard",
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: "/admin/all-users",
        name: "admin-all-users",
        component: AllUsers,
        meta: { requiresAuth: true }  
      },
      {
        path: "/admin/new-user",
        name: "admin-new-user",
        component: CreateNewUser,
        meta: { requiresAuth: true }
      },
      {
        path: "/admin/update-user",
        name: "admin-update-user",
        component: UpdateUser,
        meta: { requiresAuth: true }
      },
      {
        path: "/admin/delete-user",
        name: "admin-delete-user",
        component: DeleteUser,
        meta: { requiresAuth: true }
      },
      {
        path: "/admin/profile-settings",
        name: "admin-profile-settings",
        component: Profile,
        meta: { requiresAuth: true }
      }
    ]
  }
];
